<div class="modal-content page-publish-modal-content">
  <div class="modal-header">
    <h5 class="modal-title">{{ title }}</h5>
    <button type="button" class="btn-close shadow-none" data-bs-dismiss="modal" (click)="cancelEvent.emit()"></button>
  </div>
  <div class="modal-body">
    <div class="t-1">
      <div class="toastr-relative toastr-sm toastr-no-shadow my-4 custom-alert" toastContainer></div>
    </div>
    <form [formGroup]="pagePublishForm">
      <div class="page__form-wrap">
        <div class="row align-items-center g-2">
          <div class="col-auto">
            <label for="idUserDomain" class="col-form-label">http://</label>
          </div>
          <div class="col-sm-6 flex-grow-1">
            <ng-select
              id="idUserDomain"
              formControlName="idUserDomain"
              [items]="listDomain"
              bindLabel="domain"
              bindValue="idUserDomain"
              [clearable]="false"
              class="form-control"
            >
            </ng-select>
          </div>
          <div class="col-auto">
            <label for="name" class="col-form-label">/</label>
          </div>
          <div class="col-sm-4 flex-grow-1">
            <input type="text" class="form-control mt-1" id="name" formControlName="name" />
            <wsb-validation-error-msg [fc]="pagePublishForm.get('name')"></wsb-validation-error-msg>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <wsb-atlas-button
      variant="secondary"
      class="secondary me-3"
      data-dismiss="modal"
      (btnClick)="cancelEvent.emit()"
      [label]="labelCancelButton"
    ></wsb-atlas-button>
    <wsb-atlas-button
      variant="primary"
      [disabled]="pagePublishForm.pristine || pagePublishForm.invalid"
      (btnClick)="save.emit(getFormValue())"
      [label]="labelSaveButton"
    ></wsb-atlas-button>
  </div>
</div>
